export default function TSeriesDashboardController() {

  'ngInject';

}